import React, { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Send, MessageSquare } from "lucide-react";

export default function Chat() {
  const { user } = useAuth();
  const [params] = useSearchParams();
  const [convs, setConvs] = useState([]);
  const [active, setActive] = useState(params.get("to") || null);
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const endRef = useRef(null);

  const loadConvs = () => api.get("/conversations").then((r) => setConvs(r.data));
  const loadMsgs = (id) => api.get(`/messages/${id}`).then((r) => setMessages(r.data));

  useEffect(() => { loadConvs(); }, []);
  useEffect(() => { if (active) { loadMsgs(active); const t = setInterval(() => loadMsgs(active), 5000); return () => clearInterval(t); } }, [active]);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth", block: "nearest" }); }, [messages]);

  const send = async (e) => {
    e.preventDefault();
    if (!text.trim() || !active) return;
    await api.post("/messages", { to_user: active, text });
    setText("");
    loadMsgs(active); loadConvs();
  };

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
      <h1 className="font-display text-2xl font-bold text-secondary mb-4">Messages</h1>
      <div className="grid md:grid-cols-3 gap-4 h-[70vh]">
        <div className="border border-border rounded-xl bg-card overflow-y-auto">
          {convs.length === 0 && <div className="p-4 text-sm text-muted-foreground">Aucune conversation.</div>}
          {convs.map((c) => (
            <button key={c.user.user_id} data-testid={`conv-${c.user.user_id}`} onClick={() => setActive(c.user.user_id)}
              className={`w-full text-left p-3 border-b border-border/50 hover:bg-muted transition-colors ${active === c.user.user_id ? "bg-muted" : ""}`}>
              <div className="font-medium text-secondary text-sm">{c.user.name}</div>
              <div className="text-xs text-muted-foreground truncate">{c.last}</div>
            </button>
          ))}
        </div>
        <div className="md:col-span-2 border border-border rounded-xl bg-card flex flex-col">
          {active ? (
            <>
              <div className="flex-1 overflow-y-auto p-4 space-y-2 min-h-0">
                {messages.map((m) => (
                  <div key={m.msg_id} className={`max-w-[75%] px-3 py-2 rounded-2xl text-sm ${m.from_user === user.user_id ? "ml-auto bg-primary text-white rounded-br-sm" : "bg-muted text-secondary rounded-bl-sm"}`}>
                    {m.text}
                  </div>
                ))}
                <div ref={endRef} />
              </div>
              <form onSubmit={send} className="p-3 border-t border-border flex gap-2">
                <Input data-testid="chat-input" value={text} onChange={(e) => setText(e.target.value)} placeholder="Votre message…" />
                <Button type="submit" data-testid="chat-send" className="bg-primary hover:bg-primary/90"><Send className="w-4 h-4" /></Button>
              </form>
            </>
          ) : (
            <div className="flex-1 flex items-center justify-center text-muted-foreground flex-col gap-2">
              <MessageSquare className="w-10 h-10 opacity-30" />Sélectionnez une conversation
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
